module.exports = __webpack_public_path__ + "static/media/lottery.f04380bb.png";